<template>
    <section class="station-program" v-if="occurenceList.items && occurenceList.items.length">
        <h5 class="station-program__title">Program tv:</h5>
        <div class="station-program__list">
            <ModuleProgramItem 
                v-for="(item, index) in items" 
                :item="item" 
                :key="index"
            >
            </ModuleProgramItem>
        </div>
        <a :href="showMoreUrl" target="_blank" class="station-program__more">
            <IconHamburger class="station-program__more-icon"></IconHamburger>
            Pełny program
        </a>
    </section>
</template>

<script>
import axios from "axios";
import mapProgramBlockItem from '../../mixins/mapProgramBlockItem';
// import EmbBox from "../boxes/EmbBox.vue";
import ModuleProgramItem from "./ModuleProgramItem.vue";
import IconHamburger from "../elements/icons/IconHamburger.vue";

export default {
    name: "ModuleStationProgram",
    components: {
        ModuleProgramItem,
        IconHamburger
    },
    mixins: [mapProgramBlockItem],
    props: {
        stationCode: {
            type: String,
        }
    },
    data() {
        return {
            OCCURENCES: '/api/krainaabc/block/occurrences-now?device=www&station_code=',
            occurenceList: [],
            items: []
        };
    },
    watch: {
        stationCode() {
            this.getOccurenceList();
        }
    },
    computed: {
        showMoreUrl() {
            if(this.occurenceList && this.occurenceList.show_more && this.occurenceList.show_more.url) {
                return this.occurenceList.show_more.url;
            }
            return null;
        }
    },
    methods: {
        getOccurenceList() {
            axios.get(`${this.OCCURENCES}${this.stationCode}`).then((response) => {
                if (response.status === 200) {
                    if(response.data.data) {
                        this.occurenceList = response.data.data;
                        this.getItems();
                    }
                }
            });
        },
        getItems() {
            let mapv;
            if (this.occurenceList && this.occurenceList.items) {
                mapv = this.occurenceList.items.map(item => {
                    if (item) {
                        return this.mapProgramBlockItem(item);
                    }
                    this.items = item;
                });
                this.items = mapv;
            }
        },
    },
    mounted() {
        this.getOccurenceList();
    }
}
</script>